import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOtherMaterialReturnList, exportOtherMaterialReturn } from '../api/index.js';
import { getOrganizeTree as _getOrganizeTree } from '@/api/order';
import MaterialReturnViewDrawer from './materialReturnViewDrawer.vue';
import MaterialReturnApplyDrawer from './materialReturnApplyDrawer.vue';
import personSearchMixin from '../mixins/personSearch';
export default {
  name: 'materialReturnList',
  components: {
    MaterialReturnViewDrawer: MaterialReturnViewDrawer,
    MaterialReturnApplyDrawer: MaterialReturnApplyDrawer
  },
  mixins: [personSearchMixin],
  data: function data() {
    return {
      form: {
        code: '',
        created_by: '',
        refund_user_id: '',
        organize_id: '',
        material_id: '',
        receive_code: '',
        name: '',
        material_type: [],
        print_type: '',
        apply_time: [],
        start_time: '',
        end_time: '',
        updated_by: '',
        page: 1,
        pagesize: 20
      },
      materialTypeList: [{
        value: '3',
        label: '卡套'
      }, {
        value: '4',
        label: '券套'
      }, {
        value: '5',
        label: '手提袋'
      }, {
        value: '6',
        label: '宣传册'
      }, {
        value: '7',
        label: '画册'
      }],
      options: [],
      drawerApply: false,
      drawerView: false,
      drawerMode: 'add',
      currentRowId: '',
      drawerReturn: false,
      currentReturnId: '',
      drawerReceiveRefund: false,
      currentAction: 'refund',
      dataList: [],
      pages: {
        page: 1,
        pagesize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    drawerKey: function drawerKey() {
      return "".concat(this.drawerMode, "_").concat(this.currentRowId);
    }
  },
  created: function created() {
    this.getOrganizeTree();
    this.getList();
    this.searchReceiver('');
    this.searchOperator('');
  },
  methods: {
    searchReceiver: function searchReceiver(keyword) {
      var _this = this;
      return this.searchPerson(keyword, 'receiver', function () {
        return _this.form.refund_user_id;
      });
    },
    searchOperator: function searchOperator(keyword) {
      var _this2 = this;
      return this.searchPerson(keyword, 'operator', function () {
        return _this2.form.updated_by;
      });
    },
    getList: function getList() {
      var _this3 = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      getOtherMaterialReturnList(params).then(function (res) {
        _this3.dataList = _this3.flattenList(res.data.list || []);
        _this3.pages = res.pages || {};
      });
    },
    flattenList: function flattenList(list) {
      var rows = [];
      (list || []).forEach(function (item) {
        var parentKey = item.code || item.id || '';
        var materials = Array.isArray(item.material_items) && item.material_items.length ? item.material_items : [{}];
        materials.forEach(function (m, idx) {
          rows.push(_objectSpread(_objectSpread(_objectSpread({}, item), m), {}, {
            _rowKey: "".concat(parentKey, "_").concat(m.id || '', "_").concat(m.material_id || '', "_").concat(idx),
            _parentKey: parentKey,
            _parentSize: materials.length,
            _rowIndexInParent: idx
          }));
        });
      });
      return rows;
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column;
      var outerProps = ['id', 'code', 'created_at', 'refund_user_name', 'organize_name', 'refund_date', 'created_user_name', 'updated_user_name', 'remark'];
      var isOuter = outerProps.includes(column.property) || column.label === '操作';
      if (isOuter) {
        if (row._rowIndexInParent === 0) {
          return {
            rowspan: row._parentSize,
            colspan: 1
          };
        }
        return {
          rowspan: 0,
          colspan: 0
        };
      }
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    search: function search() {
      this.form.page = 1;
      this.getList();
    },
    handlereturn: function handlereturn() {
      this.currentReturnId = '';
      this.drawerReturn = true;
    },
    handleView: function handleView(row) {
      this.currentRowId = row.id || row.code || '';
      this.drawerView = true;
    },
    handleReturnEmitGetList: function handleReturnEmitGetList() {
      this.drawerReturn = false;
      this.getList();
    },
    handleExport: function handleExport() {
      var _this4 = this;
      var params = _objectSpread({}, this.form);
      if (this.$refs.organize) {
        params.organize_id = this.$refs.organize.getCheckedNodes(false, true).map(function (res) {
          return res.value;
        });
      }
      exportOtherMaterialReturn(params).then(function () {
        _this4.$message.warning('开始生成文件，请在【下载中心】查看进度并下载文件到本地');
      });
    },
    currentChange: function currentChange(val) {
      this.form.page = val;
      this.getList();
    },
    sizeChange: function sizeChange(val) {
      this.form.pagesize = val;
      this.form.page = 1;
      this.getList();
    },
    // 组织结构
    getOrganizeTree: function getOrganizeTree() {
      var _this5 = this;
      _getOrganizeTree().then(function (res) {
        _this5.options = res.data.list;
      });
    }
  }
};